import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <MediaSection />
        <IndexSection />
        <FaqSection />
        <RankingSection />
        <CarouselSection />
        <AboutSection />
        <TopicsSection />
        <FeaturesSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}